import { createContext, PropsWithChildren, useContext } from 'react';
import { useWittyAssistant, WittyAssistantHook } from './useWittyAssistant';

const WittyAssistantContext = createContext<WittyAssistantHook | undefined>(
  undefined,
);

export const WittyAssistantProvider = ({
  children,
}: PropsWithChildren<{}>): JSX.Element => {
  const assistant = useWittyAssistant();

  return (
    <WittyAssistantContext.Provider value={assistant}>
      {children}
    </WittyAssistantContext.Provider>
  );
};

export const useWittyAssistantContext = (): WittyAssistantHook | undefined =>
  useContext(WittyAssistantContext);
